import { ApiType } from "@gymflow/common";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { availabilityQueryKeys } from "./availabilityQueryKeys";

export function useQueryFacilityAvailabilityOverride(
  {
    api,
    availabilityOverrideId,
    facilityId,
  }: {
    api: ApiType;
    availabilityOverrideId?: number;
    facilityId?: number;
  },
  opts?: Omit<
    UseQueryOptions<
      | Awaited<
          ReturnType<ApiType["availabilityApi"]["facilityOverride"]>
        >["data"]
      | null
    >,
    "queryKey"
  >,
) {
  const result = useQuery({
    queryKey: availabilityQueryKeys.facilityOverride(
      facilityId,
      availabilityOverrideId,
    ),
    queryFn: async () => {
      const result = await api.availabilityApi.facilityOverride(
        facilityId!,
        availabilityOverrideId!,
      );
      return result.data;
    },
    enabled: !!availabilityOverrideId && !!facilityId,
    ...opts,
  });

  return result;
}
